var waGaEvents = {
	updateMailingLists: function(formSelector) {
		let mailingLists = $('.mailing-lists-picker');
		let beforeUpdatedList = new Array();

		$(mailingLists).find('input[type=hidden]').each(function() {
			let input = $(this);
			let val = input.val();

			if (val != '') {
				beforeUpdatedList.push(val);
			}
		});

		$(formSelector).submit(function( event ) {
			let afterUpdatedList = new Array();

			$(mailingLists).find('input[type=hidden]').each(function() {
				let input = $(this);
				let val = input.val();

				if (val != '') {
					afterUpdatedList.push(val);
				}
			});

			let doNotMatch = new Array();

			for( let i=0; i < afterUpdatedList.length; i++ ) {
				if(beforeUpdatedList.indexOf(afterUpdatedList[i]) == -1){
					doNotMatch.push(afterUpdatedList[i]);
				}
			}

			waGaEvents.addMailingLists(doNotMatch);
		});
	},
	addMailingLists: function(ids) {
		let eventLabel = 'Unknown Mailinglist';

		for( let i=0; i < ids.length; i++ ) {

			let listId = parseInt(ids[i]);
			console.log(listId);

			switch (listId) {
				case 1:
					eventLabel = 'Newslettter Swiss';
					break;
				case 3:
					eventLabel = 'Newslettter German';
					break;
				case 4:
					eventLabel = 'Newsletter English';
					break;
				case 29:
					eventLabel = 'Newsletter Spanish';
					break;
				case 32:
					eventLabel = 'Newsletter Italian';
					break;
			}

			this.gaEvent('Newsletter', 'Anmeldung', eventLabel, '10');
		}
	},
	jobCreditsEvent: function(credits) {
		let eventLabel = 'unknown credit';
		let eventValue = '';

		switch (credits) {
			case 1:
				eventLabel = '1 Job-Credit';
				eventValue = '170';
				break;
			case 2:
				eventLabel = '2 Job-Credit';
				eventValue = '300';
				break;
			case 3:
				eventLabel = '3 Job-Credit';
				eventValue = '240';
				break;
			case 5:
				eventLabel = '5 Job-Credit';
				eventValue = '600';
				break;
		}

		this.gaEvent('Job-Credit', 'Kauf', eventLabel, eventValue);
	},
	gaEventCaller: function() {
		$('ga-event').each((index, element) => {
			let node = $(element);

			let value = '';
			if (typeof node.data('ga-value') !== 'undefined') {
				value = node.data('ga-value');
			}

			this.gaEvent(
				node.data('ga-category'),
				node.data('ga-action'),
				node.data('ga-label'),
				value
			);
		});
	},
	gaEvent: function(category, action, label, value) {
		let data = {
			hitType: 'event',
			eventCategory: category,
			eventAction: action,
			eventLabel: label
		};

		if (typeof value !== 'undefined' && value !== '') {
			data = {
				hitType: 'event',
				eventCategory: category,
				eventAction: action,
				eventLabel: label,
				eventValue: value
			};
		}

		try {
			ga('send', data);
		} catch (e) {
			console.error('Google Analytics not loaded');
		}
	}
};
